
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateProjectdossierHiddenDocumentsDtoFormGroup() {
return new FormGroup({
    hiddenDocumentIds: new FormControl<Array<number> | undefined>([], [Validators.required]),
})
;
}
      